import { SITE_AUTHORIZATION_TOKEN } from '@/config/site'
import { toast } from 'react-toastify'
import { Configuration } from './generated'
import * as Endpoints from './generated/apis'
import { querystring } from './utils'

export class ApiServiceSite {
  config = this._createApiConfig()

  blog = new Endpoints.BlogApi(this.config)
  page = new Endpoints.PageApi(this.config)
  global = new Endpoints.SiteGlobalApi(this.config)
  services = new Endpoints.ServicesApi(this.config)
  help = new Endpoints.HelpApi(this.config)

  private _createApiConfig() {
    return new Configuration({
      basePath: process.env.NEXT_PUBLIC_API_URL.slice(0, -8),
      headers: {
        Accept: 'application/json',
        Authorization: SITE_AUTHORIZATION_TOKEN,
      },
      queryParamsStringify: querystring,
      fetchApi: this._fetchApi,
    })
  }

  private async _fetchApi(url: string, init: RequestInit): Promise<Response> {
    let response: Response = await fetch(url, init)

    if (response.status === 500) {
      toast.error('Что то пошло не так! Попробуйте позже')
    }

    return response
  }
}
